import React, { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import logo from "../assets/img/logo/logo4.png"
import { MediaSidebarData } from './MediaSidebarData';
import MediaSidebarItem from './MediaSidebarItem';
import { RxCross2 } from "react-icons/rx"
import "../styles/sidebar.css"

const Nav = () => {
  const [sidebar, setSidebar] = useState(false);

const showSideBar = () => {
  setSidebar(!sidebar);

  if (!sidebar) {
    document.body.classList.add("no-scroll");
  } else {
    document.body.classList.remove("no-scroll");
  }
};


  return (
    <nav>
      <Link to="/" className="logo">
        <img src={logo} alt="Roarz kreatives" />
        Roarz Kreatives
      </Link>
      <div className='menu-btn'>
        <span onClick={showSideBar}>Menu</span>

      </div>
      <div  className= {sidebar ? 'sidebar active' : 'sidebar' }>
        {/* Menu button (only visible when sidebar is closed) */}
        
        <div className="sidebar-header">
          <Link to="/" className="logo">
            <img src={logo} alt="Roarz kreatives" />
            Roarz Kreatives
          </Link>

          <RxCross2 className="cross-btn" onClick={showSideBar} />
        </div>

        {MediaSidebarData.map((item, index) => (
          <MediaSidebarItem key={index} item={item} onClick={showSideBar} />
        ))}
      </div>
    </nav>
  );
};

export default Nav;
